import React, { useState, useEffect, useContext } from 'react';

//components
import CaretButton from '../global/buttons/CaretButton';
import FixedPositionContextMenu from '../global/lists/FixedPositionContextMenu/FixedPositionContextMenu';
import Icon from '../icons/Icons';

//interfaces
import { IconLibrary } from  '@/interfaces/IconLibrary';
import { IGroups, IUsers } from  '@/interfaces/api/ContentAudience';
import Loading from '../global/LoadingDots';
import { ContentAudienceContext } from './ContentAudienceContext';
import { ResourcePermission } from  '@/interfaces/orgSettings';
import { isOrganisationAdmin } from  '@/helpers/OrgSettings';



const EditPermissionsControl = ({user, group, setAudiencePermission}: {user?:IUsers, group?: IGroups, setAudiencePermission: (isGroup: boolean, name: string, id: number, permission: ResourcePermission)=>void}) => {
    const [currentPermissions, setCurrentPermissions ] = useState<ResourcePermission>()
    const [controlIsOpen, setControlIsOpen] = useState<boolean>(false);

    const {updatingUserOrGroupIds} = useContext(ContentAudienceContext)

    useEffect(() => {
        if (user) {
            setCurrentPermissions(user?.permission || ResourcePermission.READ)
        } else if (group) {
            setCurrentPermissions(group?.permission || ResourcePermission.READ)
        }
    }, [user?.permission, group?.permission])

    function setPermission(newPermission: ResourcePermission){
        if (currentPermissions === newPermission) {
            return;
        }
        if (user) {
           setAudiencePermission(false, user.userName, user.id, newPermission);
        }
        if(group) {
            setAudiencePermission(true, group.name, group.id, newPermission);
        }
    }

    function isLoading(){
        const uOrG = user || group

        return updatingUserOrGroupIds.includes(uOrG.id)
    }

    function getContentMessage(action: ResourcePermission){
        switch(action) {
            case ResourcePermission.READ:
                return <><span className="title">View Only</span><span>Can find and view this content.</span></>;
            case ResourcePermission.MANAGE:
                return <>
                    <span className="title">
                        Can Edit
                        {isAdmin() && <>
                            <Icon iconName={IconLibrary.USER_COG} sizeInPx='10' color="#343D4C"/>
                            <span className='admin-text'>
                                (Organisation or Workspace Editor)
                            </span>
                        </>}
                    </span>
                    <span>Has edit access to this content and any nested items unless specified otherwise.</span></>
        }
    }

    function showCheck(value: ResourcePermission, currentPermissions: ResourcePermission) {
        return value === currentPermissions
            ? <Icon className='active-icon' iconName={IconLibrary.CHECK} sizeInPx='12' color='#a5c83e'/>
            : <></>
    }

    function getContent(action: ResourcePermission, currentPermissions: ResourcePermission) {
        return (
            <div className='edit-permission-button-choice-text'>
                {getContentMessage(action)}
                {showCheck(action, currentPermissions)}
            </div>
        )
    }

    function isAdmin(){
        const userOrGroup = user || group
        return isOrganisationAdmin(userOrGroup.permission, userOrGroup.grantType)
    }
    
    function getStatus() {
        return isAdmin() || currentPermissions === ResourcePermission.MANAGE
        ? <>Can Edit {isAdmin() && <Icon iconName={IconLibrary.USER_COG} sizeInPx='10' color="#343D4C"/>}</>
        : 'View Only'
    }

    function getStatusString() {
        return currentPermissions === ResourcePermission.MANAGE
        ? 'Can Edit'
        : 'View Only'
    }
    
    return (
        <>
            {isLoading()
            ? <Loading />
            : <FixedPositionContextMenu 
                className='edit-permissions'
                controlIsOpen={controlIsOpen}
                setControlIsOpen={setControlIsOpen}
                anchorButton={
                    <CaretButton
                        content={getStatus()}
                        ariaLabel={`${getStatusString()}: Select to change permission options for ${user?.userName || group?.name}`} 
                        onButtonClick={() => setControlIsOpen(true)}
                    />
                }
                closeOnScrollTarget='.simplebar-content-wrapper'
                containerQuerySelector='.ReactModal__Content'
                menuButtons={[
                    !isAdmin()
                        ?  {content: getContent(ResourcePermission.READ, currentPermissions) , onClick: () => setPermission(ResourcePermission.READ)}
                        : undefined,
                    {content: getContent(ResourcePermission.MANAGE, currentPermissions), onClick: () => setPermission(ResourcePermission.MANAGE)}
                ].filter(mo => mo)}
                manualOffset={{top: 5, right: 100}}
            />}
        </>
        
    )
}

export default EditPermissionsControl